export const BENCHMARK_RATE_DEFAULT = [
  "height",
  "mid",
  "low"
];

export const CHECKLIST_DEFAULT = [
  {
    "value": "height",
    "key": "benchmark_high",
    "name": "Benchmark-High",
    "nameEn": "Benchmark-High",
    "nameCn": "行业基准-好"
  },
  {
    "value": "mid",
    "key": "benchmark_mid",
    "name": "Benchmark-Mid",
    "nameEn": "Benchmark-Mid",
    "nameCn": "行业基准-中"
  },
  {
    "value": "low",
    "key": "benchmark_low",
    "name": "Benchmark-Low",
    "nameEn": "Benchmark-Low",
    "nameCn": "行业基准-差"
  }
];